// extracted by mini-css-extract-plugin
export default {"card":"pingo-module__card--DWr7A","bubbleContainer":"pingo-module__bubbleContainer--KC5x2"};